import { ModalPlugin } from 'bootstrap-vue';
import Vue from 'vue';
import VueNotifications from 'vue-notification';
import VueProgressBar from 'vue-progressbar';
import progressbarConfig from './config/progressbar.config';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import HttpService from './services/http.service';
import AuthService from './services/auth.service';

Vue.use(VueNotifications);
Vue.use(ModalPlugin);
Vue.use(VueProgressBar, progressbarConfig);

Vue.config.productionTip = false;

let initDone = false;

router.beforeEach((to, from, next) => {
  if (!initDone) {
    store.dispatch('init', to);
    initDone = true;
  }
  next();
});

router.afterEach(() => {
  store.commit('sidebar/isSidebarOpen', false);
});

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

HttpService.onUnauthorized = () => store.dispatch('auth/unauthorized');
HttpService.onProgressStart = () => app.$Progress.start();
HttpService.onProgressFinish = () => app.$Progress.finish();
AuthService.onAuthSuccess = (res, isAuthenticated) => store.dispatch('auth/authSuccess', {
  isAuthenticated: isAuthenticated,
  data: res,
});
